import React from 'react';
import {Trip} from '../../react-app-env';

export const TripContext = React.createContext<Trip>(null as any);

export function useTrip() {
  return React.useContext(TripContext);
}
